import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-81663f40"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "card card-stretch shadow",
  style: {"margin-bottom":"10px"}
}
const _hoisted_2 = {
  class: "card-body",
  style: {"padding":"15px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Эхлэл")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Тайлан")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Хянан шалгагч")
const _hoisted_6 = {
  key: 0,
  class: "row g-5"
}
const _hoisted_7 = { class: "col-lg-12" }
const _hoisted_8 = { class: "card shadow" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "el-icon-notebook-2 fs-2 text-dark" }),
    /*#__PURE__*/_createTextVNode(" "),
    /*#__PURE__*/_createElementVNode("b", null, "Тайлан гаргах")
  ])
], -1))
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = {
  key: 0,
  class: "update-request-report"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "update-request-report__heading" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h4", null, "Хүсэлт шийдвэрлэлтийн тайлан"),
    /*#__PURE__*/_createElementVNode("p", null, " Тайлангийн он заавал сонгож, үүсгэсэн ажилтан болон төлөвөөр шүүж XLSX файлаар татна. ")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "update-request-report__format" }, "XLSX")
], -1))
const _hoisted_13 = { class: "update-request-report__controls" }
const _hoisted_14 = { class: "update-request-report__control" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Он "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_16 = { class: "update-request-report__control" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Үүсгэсэн ажилтан", -1))
const _hoisted_18 = { class: "update-request-report__control" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Төлөв", -1))
const _hoisted_20 = ["disabled", "data-kt-indicator"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createTextVNode(" Excel татах  "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-excel" })
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"line-height":"2.0","margin-bottom":"0","font-weight":"600"} }, " Нийт үлдэгдэлтэй зээлийн тоо /байгууллагаар/ ", -1))
const _hoisted_25 = ["data-kt-indicator"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createTextVNode(" Татах  "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download text-success" })
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"line-height":"2.0","margin-bottom":"0","font-weight":"600","word-break":"break-all","white-space":"normal"} }, " Зээлийн мэдээллийн жагсаалт /үлдэгдэлтэй/ ", -1))
const _hoisted_31 = ["data-kt-indicator"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createTextVNode(" Татах  "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download text-success" })
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"line-height":"2.0","margin-bottom":"0","font-weight":"600"} }, " Лавлагаа /2021 оны 06 сарын 30 байдлаар/ ", -1))
const _hoisted_37 = ["data-kt-indicator"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createTextVNode(" Татах  "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download text-success" })
], -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_40 = [
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"line-height":"2.0","margin-bottom":"0","font-weight":"600","word-break":"break-all","white-space":"normal"} }, " Зээлийн мэдээллийн лавлагааны шимтгэл төлөлт /хэрэглэгч байгууллагаар/ ", -1))
const _hoisted_43 = { style: {"float":"left"} }
const _hoisted_44 = { style: {"float":"right","color":"#8492a6","font-size":"13px"} }
const _hoisted_45 = ["data-kt-indicator"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createTextVNode(" Татах  "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download text-success" })
], -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_50 = { class: "report-history" }
const _hoisted_51 = { class: "report-history__heading" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Тайлан таталтын түүх"),
  /*#__PURE__*/_createElementVNode("p", null, "Тайлан, хэрэглэгч, байгууллага болон огноогоор хайна.")
], -1))
const _hoisted_53 = { class: "report-history__filters" }
const _hoisted_54 = { class: "report-history__pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    (this.isu)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                (_ctx.canDownloadUpdateRequestReport)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
                      _hoisted_12,
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _hoisted_15,
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.updateRequestYear,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.updateRequestYear) = $event)),
                            size: "small",
                            placeholder: "Он сонгох",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.updateRequestYears, (year) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: year,
                                  label: year,
                                  value: String(year)
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _hoisted_17,
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.updateRequestCreatedBy,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.updateRequestCreatedBy) = $event)),
                            size: "small",
                            filterable: "",
                            clearable: "",
                            placeholder: "Бүгд",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.updateRequestCreatedByOptions, (employee) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: employee.value,
                                  label: employee.text,
                                  value: employee.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.updateRequestStatus,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.updateRequestStatus) = $event)),
                            size: "small",
                            clearable: "",
                            placeholder: "Бүгд",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.updateRequestStatuses, (status) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: status.value,
                                  label: status.text,
                                  value: status.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("button", {
                          class: "el-button el-button--primary el-button--small update-request-report__button",
                          disabled: 
                    _ctx.updateRequestDownloading || _ctx.updateRequestFiltersLoading
                  ,
                          "data-kt-indicator": _ctx.updateRequestDownloading ? 'on' : 'off',
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.downloadUpdateRequestReport && _ctx.downloadUpdateRequestReport(...args)))
                        }, _hoisted_23, 8, _hoisted_20)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.canDownloadUpdateRequestReport)
                  ? (_openBlock(), _createBlock(_component_el_divider, { key: 1 }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_row, {
                  class: "report-option",
                  size: "mini",
                  type: "flex",
                  justify: "space-between"
                }, {
                  default: _withCtx(() => [
                    _hoisted_24,
                    _createElementVNode("button", {
                      class: "el-button el-button--success el-button--mini is-plain",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.getReportTotalLoans && _ctx.getReportTotalLoans(...args))),
                      "data-kt-indicator": this.loadButton
                    }, _hoisted_28, 8, _hoisted_25)
                  ]),
                  _: 1
                }),
                _hoisted_29,
                _createVNode(_component_el_row, {
                  class: "report-option",
                  size: "mini",
                  type: "flex",
                  justify: "space-between"
                }, {
                  default: _withCtx(() => [
                    _hoisted_30,
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_space, { size: "small" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: this.yearValue,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((this.yearValue) = $event)),
                            "collapse-tags": "",
                            size: "mini",
                            placeholder: "-- Он сонгох --"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.years, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.yearValue,
                                  label: item.yearLabel,
                                  value: item.yearValue
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_select, {
                        modelValue: this.monthValue,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((this.monthValue) = $event)),
                        "collapse-tags": "",
                        size: "mini",
                        placeholder: "-- Сар сонгох --"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.monthValue,
                              label: item.monthLabel,
                              value: item.monthValue
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("button", {
                      class: "el-button el-button--success el-button--mini is-plain",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.getReportInvoiceReport && _ctx.getReportInvoiceReport(...args))),
                      "data-kt-indicator": this.loadButton
                    }, _hoisted_34, 8, _hoisted_31)
                  ]),
                  _: 1
                }),
                _hoisted_35,
                _createVNode(_component_el_row, {
                  class: "report-option",
                  size: "mini",
                  type: "flex",
                  justify: "space-between"
                }, {
                  default: _withCtx(() => [
                    _hoisted_36,
                    _createVNode(_component_el_input, {
                      class: "col-md-2",
                      modelValue: this.registerno,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((this.registerno) = $event)),
                      size: "mini",
                      placeholder: "Регистрийн дугаар"
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("button", {
                      class: "el-button el-button--success el-button--mini is-plain",
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.getReportReportInquiry && _ctx.getReportReportInquiry(...args))),
                      "data-kt-indicator": this.loadButton
                    }, _hoisted_40, 8, _hoisted_37)
                  ]),
                  _: 1
                }),
                _hoisted_41,
                _createVNode(_component_el_row, {
                  class: "report-option",
                  size: "mini",
                  type: "flex",
                  justify: "space-between"
                }, {
                  default: _withCtx(() => [
                    _hoisted_42,
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_space, { size: "small" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: this.orgValue,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((this.orgValue) = $event)),
                            "collapse-tags": "",
                            filterable: "",
                            size: "mini",
                            placeholder: "-- Байгууллага сонгох --"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.orgList, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.orgcode,
                                  label: item.orgname,
                                  value: item.orgcode
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_43, _toDisplayString(item.orgname), 1),
                                    _createElementVNode("span", _hoisted_44, _toDisplayString(item.orgcode), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_space, { size: "small" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            size: "mini",
                            type: "date",
                            modelValue: this.dateOfStart,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((this.dateOfStart) = $event)),
                            placeholder: "YYYY-MM-DD"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_space, { size: "small" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            size: "mini",
                            type: "date",
                            modelValue: this.dateOfEnd,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((this.dateOfEnd) = $event)),
                            placeholder: "YYYY-MM-DD"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("button", {
                      class: "el-button el-button--success el-button--mini is-plain",
                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.getReportInvoicePayment && _ctx.getReportInvoicePayment(...args))),
                      "data-kt-indicator": this.loadButton
                    }, _hoisted_48, 8, _hoisted_45)
                  ]),
                  _: 1
                }),
                _hoisted_49,
                _createElementVNode("section", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _hoisted_52,
                    _createElementVNode("button", {
                      class: "el-button el-button--default el-button--small",
                      onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.resetHistoryFilters && _ctx.resetHistoryFilters(...args)))
                    }, " Цэвэрлэх ")
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.historyText,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.historyText) = $event)),
                      size: "small",
                      clearable: "",
                      placeholder: "Тайлангийн нэрээр хайх",
                      onKeyup: _withKeys(_ctx.applyHistoryFilters, ["enter"])
                    }, null, 8, ["modelValue", "onKeyup"]),
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.historyReportType,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.historyReportType) = $event)),
                      size: "small",
                      clearable: "",
                      placeholder: "Тайлангийн төрөл"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Үндсэн тайлан",
                          value: "main"
                        }),
                        _createVNode(_component_el_option, {
                          label: "Хүсэлт шийдвэрлэлт",
                          value: "update_request"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.historyUsername,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.historyUsername) = $event)),
                      size: "small",
                      clearable: "",
                      placeholder: "Тайлан гаргасан",
                      onKeyup: _withKeys(_ctx.applyHistoryFilters, ["enter"])
                    }, null, 8, ["modelValue", "onKeyup"]),
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.historyOrgcode,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.historyOrgcode) = $event)),
                      size: "small",
                      clearable: "",
                      placeholder: "Байгууллагын код",
                      onKeyup: _withKeys(_ctx.applyHistoryFilters, ["enter"])
                    }, null, 8, ["modelValue", "onKeyup"]),
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.historyDateRange,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.historyDateRange) = $event)),
                      type: "daterange",
                      size: "small",
                      "range-separator": "-",
                      "start-placeholder": "Эхлэх огноо",
                      "end-placeholder": "Дуусах огноо",
                      "value-format": "YYYY-MM-DD",
                      style: {"width":"100%"}
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("button", {
                      class: "el-button el-button--primary el-button--small",
                      onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.applyHistoryFilters && _ctx.applyHistoryFilters(...args)))
                    }, " Хайх ")
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                    data: this.reportLog,
                    "element-loading-text": "Өгөгдөл татаж байна...",
                    "empty-text": "Өгөгдөл байхгүй байна.",
                    size: "mini",
                    "max-height": "300",
                    border: "",
                    "cell-style": { textAlign: 'center' },
                    "header-cell-style": { textAlign: 'center' }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        label: "№",
                        width: "40"
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Тайлангийн нэр",
                        prop: "reportname",
                        sortable: ""
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Тайлангийн параметер",
                        prop: "params",
                        sortable: ""
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Байгууллагын код",
                        prop: "orgcode",
                        sortable: ""
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Тайлан гаргасан",
                        prop: "userid",
                        sortable: ""
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Татсан огноо",
                        prop: "actiondate",
                        formatter: _ctx.$filters.formatDateYMDHMS,
                        sortable: ""
                      }, null, 8, ["formatter"]),
                      _createVNode(_component_el_table_column, {
                        label: "Файлын хэмжээ",
                        prop: "filesize",
                        sortable: ""
                      })
                    ]),
                    _: 1
                  }, 8, ["data"])), [
                    [_directive_loading, this.reportLogLoading]
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createVNode(_component_el_pagination, {
                      background: "",
                      "current-page": _ctx.historyPage,
                      "page-size": _ctx.historyPageSize,
                      "page-sizes": [10, 20, 50, 100],
                      total: _ctx.historyTotal,
                      layout: "total, sizes, prev, pager, next",
                      onSizeChange: _ctx.handleHistoryPageSizeChange,
                      onCurrentChange: _ctx.handleHistoryPageChange
                    }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}